module.exports = __webpack_public_path__ + "img/bg_login.5e5294af.png";